<template>
  <div class="container">
    <div class="home">
      <h1 class="home__title">Jorify - Your CG Products.</h1>
      <ProjectItem
        v-for="(project, index) in projects"
        :key="index"
        :name="project.name"
        :first_line="project.first_line"
        :second_line="project.second_line"
        :description="project.description"
        :label="project.label"
        :image="project.image"
        :videoOptions="project.videoOptions"
        :slug="project.slug"
      />
      <ProjectImageItem
        v-for="(project, index) in image_projects"
        :key="index"
        :name="project.name"
        :first_line="project.first_line"
        :second_line="project.second_line"
        :description="project.description"
        :label="project.label"
        :image="project.image"
        :images="project.images"
        :videoOptions="project.videoOptions"
        :slug="project.slug"
      />
    </div>
  </div>
</template>

<script>
import store from "@/store.js";
import ProjectItem from "@/components/ProjectItem.vue";
import ProjectImageItem from "@/components/ProjectImageItem.vue";

export default {
  name: "home",
  components: {
    ProjectItem,
    ProjectImageItem,
  },
  data() {
    return {
      projects: store.projects,
      image_projects: store.image_projects,
    };
  },
};
</script>

<style scoped>
.home {
  padding-bottom: 80px;
  margin-bottom: 56px;
}
.home__title {
  visibility: hidden;
  height: 0;
}
</style>
